module.exports = __webpack_public_path__ + "img/36577-029.9f56bd10.jpg";